'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fPanel$002ejs from "@ui5/webcomponents/dist/Panel.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dTitle$002dLevel$0024 from "./be.doeraene.webcomponents.ui5.configkeys.-Title-Level$.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Panel$() {
  this.Db = null;
  this.D7 = null;
  this.D8 = false;
  this.D9 = null;
  this.Da = false;
  $n_Lbe_doeraene_webcomponents_ui5_Panel$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fPanel$002ejs.default;
  this.Db = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-panel", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_Panel$ as $c_Lbe_doeraene_webcomponents_ui5_Panel$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Panel$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Panel$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Panel$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Panel$ as $h_Lbe_doeraene_webcomponents_ui5_Panel$ };
$h_Lbe_doeraene_webcomponents_ui5_Panel$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.Db;
});
$p.BK = (function() {
  if ((!this.D8)) {
    this.D7 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "header-level", $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dTitle$002dLevel$0024.$m_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$().wV()));
    this.D8 = true;
  }
  return this.D7;
});
$p.BL = (function() {
  if ((!this.Da)) {
    this.D9 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "header-text", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Da = true;
  }
  return this.D9;
});
var $d_Lbe_doeraene_webcomponents_ui5_Panel$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Panel$, "be.doeraene.webcomponents.ui5.Panel$", ({
  gk: 1,
  ar: 1,
  b8: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Panel$ as $d_Lbe_doeraene_webcomponents_ui5_Panel$ };
var $n_Lbe_doeraene_webcomponents_ui5_Panel$;
function $m_Lbe_doeraene_webcomponents_ui5_Panel$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Panel$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Panel$ = new $c_Lbe_doeraene_webcomponents_ui5_Panel$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Panel$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Panel$ as $m_Lbe_doeraene_webcomponents_ui5_Panel$ };
